import {
  settingsPortalPantryPath,
  settingsPortalUsersPath,
  settingsPortalSmtpAccountPath
} from '../../../../routes/Paths';

export const NAV_KEYS = {
  PANTRY: 'pantry',
  USERS: 'users',
  SMTP_ACCOUNT: 'smtp-account'
};

export const navKeysByPath = {
  [settingsPortalPantryPath]: NAV_KEYS.PANTRY,
  [settingsPortalUsersPath]: NAV_KEYS.USERS,
  [settingsPortalSmtpAccountPath]: NAV_KEYS.SMTP_ACCOUNT
};
